import { useState, useEffect } from "react";
import { useOccurrenceRegister } from "contexts/register/OccurrenceContext";

import { IExpressValidatorError } from "interfaces/ExpressError";
import { IOccurrence } from "interfaces/Occurrence";

import {
  handleOccurrenceSubmit,
  handleOccurrenceUpdate,
} from "services/handles/OccurrenceHandles";

import { StepModalTemplate } from "templates/StepModalTemplate";

import { transformValidatorError } from "utils/transformValidatorError";
import { OccurrenceForm } from "../../../Forms/Occurrence/OccurrenceForm";
import { VehicleForm } from "../../../Forms/Occurrence/VehicleForm";

import { Tab } from "../../../TabHeader";

import * as S from "./styles";

type Props = {
  opened: boolean;
  setOpened: (value: boolean) => void;
  occurrenceData?: IOccurrence;
};

function StepRegisterOccurrence({ opened, setOpened, occurrenceData }: Props) {
  const {
    occurrence,
    retrieveOccurrence,
    setErrors,
    searching,
    setOccurrence,
    setVehicle,
    isManual,
    vehicle,
    resetOccurrence,
    isSubclientAddressRegister,
    filterClient,
    filterSubClient,
    selectedPolicemen
  } = useOccurrenceRegister();
  const [vehicleTabCount, setVehicleTabCount] = useState<number>();

  const tabs = [
    { index: 0, text: "Dados de ocorrência" },
    { index: 1, text: "Dados de Veículo" },
    // { index: 2, text: `Últimas localizações (${vehicleTabCount || 0})` },
  ];

  const [tab, setTab] = useState<Tab>(tabs[0]);
  type workType = "Policial" | "Assistente";
  const [invalidTabs, setInvalidTabs] = useState<Tab[]>([]);
  const [deactivatedTabs, setDeactivatedTabs] = useState<Tab[]>([]);
  const [patrimonialType, setPatrimonialType] = useState(1);
  const [workType, setWorkType] = useState<workType>("Policial");

  const [sending, setSending] = useState<boolean>(false);
  const [hasNumber, setHasNumber] = useState<boolean>(false);

  useEffect(() => {
    setDeactivatedTabs([]);
    setOccurrence((value) => {
      value.patrimonialType = patrimonialType;
      value.workType = workType;
      return value;
    });
    if (patrimonialType === 1 || occurrenceData?.patrimonialType === 1) {
      setDeactivatedTabs((list) => [...list, tabs[1], tabs[2]]);
      return;
    }
    setDeactivatedTabs([]);
  }, [patrimonialType, occurrenceData, workType]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (occurrenceData) {
      setInvalidTabs([]);
      setErrors({});
      setPatrimonialType(occurrenceData.patrimonialType);
      retrieveOccurrence(occurrenceData);

      occurrenceData.lastCoords &&
        setVehicleTabCount(occurrenceData.lastCoords.length);

      return;
    }
  }, [occurrenceData]); // eslint-disable-line react-hooks/exhaustive-deps
  async function handleSubmit() {
    setSending(true);

    if (occurrenceData) {
      const dataWithoutVehicle = {
        id: occurrenceData.id,
        lastCoords: occurrence.lastCoords,
        patrimonialType: occurrence.patrimonialType,
        superficialClient: occurrence?.superficialClient?.id,
        numberBO: occurrence.numberBO,
        lastCoordX: occurrence.lastCoordX,
        lastCoordY: occurrence.lastCoordY,
        postalCode: occurrence.postalCode,
        street: occurrence.street,
        number: occurrence.number,
        district: occurrence.district,
        uf: occurrence.uf,
        city: occurrence.city,
        coordX: occurrence.coordX,
        coordY: occurrence.coordY,
        workType: occurrence.workType,
        superficialAddressId:
          occurrenceData.occurrencesSuperficialAddresses.superficialAddress.id,
      };

      const dataWithVehicle = {
        ...dataWithoutVehicle,
        superficialVehicle: vehicle,
      };

      return await handleOccurrenceUpdate(
        occurrence.patrimonialType === 2 ? dataWithVehicle : dataWithoutVehicle
      )
        .then(async (res) => {
          if (res.status === true) {
            localStorage.setItem(
              "message",
              "Os dados da ocorrência residencial foram salvos corretamente."
            );
            window.location.reload();
            return;
          }

          treatValidatorErrors(res.data.error);
        })
        .catch((error) => {
          treatValidatorErrors(error.data);
        })
        .finally(() => {
          setSending(false);
        });
    }

    const dataWithoutVehicle = {
      lastCoords: occurrence.lastCoords,
      patrimonialType: occurrence.patrimonialType,
      numberBO: occurrence.numberBO,
      lastCoordX: occurrence.lastCoordX,
      lastCoordY: occurrence.lastCoordY,
      postalCode: occurrence.postalCode,
      street: occurrence.street,
      number: occurrence.number,
      district: occurrence.district,
      uf: occurrence.uf,
      city: occurrence.city,
      coordX: occurrence.coordX,
      coordY: occurrence.coordY,
      isManual,
      Client: filterClient,
      superficialAddressId: occurrence.superficialAddressId,
      workType: occurrence.workType,
      policemen: selectedPolicemen,
      ...(patrimonialType === 1 && {
        superficialClient: {
          id: occurrence.superficialClient?.id,
        },
      }),
      superficialClientId: isSubclientAddressRegister
        ? filterSubClient
        : undefined,
    };

    const dataWithVehicle = {
      ...dataWithoutVehicle,
      superficialVehicle: vehicle,
    };

    // setSending(true);

    await handleOccurrenceSubmit(
      occurrence.patrimonialType === 2 ? dataWithVehicle : dataWithoutVehicle
    )
      .then(async (res) => {
        if (res.status === 201 || res.status === 200) {
          if (occurrence.workType === undefined) {
            setOccurrence((value) => {
              value.workType = "Policial";
              return value;
            });
          }
          if (res.status === 400) {
            treatValidatorErrors(res.data.error);
          } else {
            const toastMessage =
              occurrence.patrimonialType === 2
                ? "Os dados da ocorrência veicular foram cadastrados corretamente."
                : "Os dados da ocorrência residencial foram cadastrados corretamente.";

            localStorage.setItem("message", toastMessage);
            window.location.reload();
            return;
          }
        }
        treatValidatorErrors(res.data.error);
      })
      .catch((err) => {
        console.log(
          "🚀 ~ file: index.tsx ~ line 247 ~ handleSubmit ~ err",
          err
        );
      })
      .finally(() => {
        setSending(false);
      });
  }

  function setTabAsInvalid(tab: Tab) {
    setInvalidTabs((list) => [...list, tab]);
  }

  function treatValidatorErrors(validatorErrors: IExpressValidatorError) {
    setInvalidTabs([]);
    if (validatorErrors === undefined) return;
    const { errors } = transformValidatorError(validatorErrors);
    setTabAsInvalid(tabs[0]);

    setErrors(errors);
  }

  function onTabClick(_tab: Tab) {
    setTab(_tab);
  }

  function onVehicleLocationChange(count: number) {
    setVehicleTabCount(count);
  }

  return (
    <StepModalTemplate
      deactivatedTabs={deactivatedTabs}
      title={`${occurrenceData ? "Editar" : "Cadastrar"} ocorrência`}
      buttonText={`${occurrenceData ? "Salvar" : "Efetuar cadastro"}`}
      opened={opened}
      setOpened={() => {
        resetOccurrence();
        setOpened(false);
      }}
      tabs={tabs}
      invalidTabs={invalidTabs}
      selectedTab={tab}
      sending={sending}
      setSelectedTab={onTabClick}
      handleSubmit={handleSubmit}
    >
      <S.Container>
        {searching && (
          <S.LoadingWrapper>
            <span>Buscando dados da ocorrência...</span>
          </S.LoadingWrapper>
        )}

        {!searching && (
          <S.SubContainer>
            {tab.index === 0 && (
              <OccurrenceForm
                patrimonialType={patrimonialType}
                setPatrimonialType={setPatrimonialType}
                occurrenceData={occurrenceData}
                workType={workType}
                setWorkType={setWorkType}
                hasNumber={hasNumber}
              />
            )}

            {tab.index === 1 && patrimonialType === 2 && (
              <VehicleForm onVehicleLocationChange={onVehicleLocationChange} />
            )}
          </S.SubContainer>
        )}
      </S.Container>
    </StepModalTemplate>
  );
}

export { StepRegisterOccurrence };
